<template>
  <div>
    <blockquote
      :class="platformClass"
      :cite="cite"
      :data-instgrm-permalink="dataInstgrmPermalink"
      :data-video-id="tiktokVideoId"
      :data-url="dataUrl"
      :data-instgrm-version="dataInstgrmVersion"
     >
      <template v-if="isTikTok">
        <section :class="platformClass"></section>
      </template>
      <template v-else-if="isTwitter">
        <a :href="dataUrl" target="_blank" :class="platformClass"></a>
      </template>
      <template v-else-if="isInstagram">
        <a :href="dataInstgrmPermalink" target="_blank" rel="noopener noreferrer"></a>
      </template>
    </blockquote>
  </div>
  
</template>

<script>

export default {
  props: {
    platformClass:{
      type: String,
      default: ''
    },
    tiktokVideoId: {
      type: String,
      default: null
    },
    cite: {
      type: String,
      default: null
    },
    dataInstgrmPermalink: {
      type: String,
      default: null
    },
    dataUrl:{
      type: String,
      default: null
    },
    dataInstgrmVersion:{
      type: String,
      default: null
    },
    isTikTok: {
      type: Boolean,
      default: false
    },
    isTwitter: {
      type: Boolean,
      default: false
    },
    isInstagram: {
      type: Boolean,
      default: false
    }
  }
};
</script>